import * as React from 'react';

// Types
import { FieldProps } from '../../../manifests/types';

interface determineRequiredProps {
    required?: FieldProps['required'];
    values: Record<string, any>;
    ancillaryData: Record<string, any>;
}

export const useDynamicRequired = () => {
    const determineRequired = ({ required, values, ancillaryData }: determineRequiredProps): boolean | undefined => {
        if (typeof required === 'function') {
            return required(ancillaryData, values);
        } else {
            return required;
        }
    };

    return { determineRequired };
};

export default useDynamicRequired;
